<template>
    <div class="ui-wrapper" v-loading="loading">
        <div class="container ui-container-bordered">
            <h2 class="mt-3 mb-4">Fulfillment Request</h2>

            <div class="row mb-5">
                <div class="col-4">

                    <h4 class="mb-3">Campaign</h4>
                    <div class="field">
                        Employer<br>
                        <el-select 
                            v-model="form_data.employer_id" 
                            clearable 
                            filterable 
                            placeholder="Select an employer"
                            style="width: 100%" 
                            @change="() => { refreshCampaigns(); refreshCurrentFulfillmentRequests() }"
                        >
                            <el-option
                                v-for="(option) in lists.employers"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="field">
                        Campaign<br>
                        <el-select 
                            v-model="form_data.campaign_id" 
                            clearable 
                            filterable 
                            placeholder="Select a campaign"
                            style="width: 100%" 
                            :disabled="! form_data.employer_id"
                            @change="() => { refreshJobs(); refreshPeriods(); refreshCurrentFulfillmentRequests(); }"
                        >
                            <el-option
                                v-for="(option) in lists.campaigns"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="field">
                        Month<br>
                        <el-select
                            v-model="form_data.request_for_periods"
                            clearable
                            filterable
                            multiple
                            placeholder="Select a month"
                            style="width: 100%"
                            :disabled="! form_data.campaign_id"
                        >
                            <el-option
                                v-for="(option) in lists.periods"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id"
                                :disabled="option.disabled">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="field">
                        Job (optional)<br>
                        <el-select 
                            v-model="form_data.job_id" 
                            clearable 
                            filterable 
                            placeholder="Select a job"
                            style="width: 100%" 
                            :disabled="! form_data.campaign_id"
                            @change="refreshJobInfo"
                        >
                            <el-option
                                v-for="(option) in lists.jobs"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="col-1"></div>
                <div class="col-7">

                    <fulfillment-new-current-requests
                        :current_fulfillment_requests="this.current_fulfillment_requests"
                    >
                    </fulfillment-new-current-requests>
                </div>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Job</h4>
                <div class="field">
                    Pay<br>
                    <el-input v-model="form_data.job_pay"></el-input>
                </div>

                <div class="field">
                    Hometime<br>
                    <el-input v-model="form_data.job_hometime"></el-input>
                </div>

                <div class="field">
                    Equipment Type<br>
                    <el-input v-model="form_data.job_equipment"></el-input>
                </div>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Leads</h4>
                <div class="field">
                    How many leads are you ordering?<br>
                    <el-input v-model="form_data.leads_ordered" style="width: 25%"></el-input>
                    <!-- Campaign Combo Direct received 30/1000 apps so far. Estimated fulfillment need: 400 apps - SEE MIRO -->
                </div>

                <div class="field">
                    How do you want these lead? (pacing)<br>
                    <el-radio v-model="form_data.leads_pacing" label="even">Try to get even number between now and due date
                        <el-tooltip class="item" effect="dark" content="Example: if you ask for 40 leads between the 1st and 30th of the month, this would be about 10 per week" placement="top">
                            <span class="fa-stack ml-3" style="vertical-align: top;">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-info fa-stack-1x fa-inverse"></i>
                            </span>
                        </el-tooltip>
                    </el-radio>
                    
                    <br>
                    <el-radio v-model="form_data.leads_pacing" label="fast" style="width: 170px;">Just get me the leads now</el-radio>
                </div>

                <div class="field">
                    Order type<br>
                    <el-radio v-model="form_data.order_type" label="Performance Fulfillment"></el-radio><br>
                    <el-radio v-model="form_data.order_type" label="Subscription Fulfillment"></el-radio><br>
                    <el-radio v-model="form_data.order_type" label="DriverBoost Order"></el-radio><br>
                    <el-radio v-model="form_data.order_type" label="Roll Over"></el-radio><br>
                </div>

                <div class="field">
                    Notes<br>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 10 }"
                        v-model="form_data.request_notes">
                    </el-input>
                </div>
            </div>

            <div style="display: flex; justify-content: center">
                <btn cssClass="btn-lg btn-dark" :click="save">Send Request</btn>
            </div>
        </div>
    </div>
</template>

<script>
import FulfillmentNewCurrentRequests from "./fulfillment-new/fulfillment-new-current-requests";

    export default {
        props: [
        ],
        components: {
            FulfillmentNewCurrentRequests,
        },
        data() {
            return {
                loading: true,
                form_data: {
                    employer_id: null,
                    campaign_id: null,
                    job_id: null,
                    job_pay: "",
                    job_hometime: "",
                    job_equipment: "",
                    leads_ordered: null,
                    leads_pacing: null,
                    is_autocancel: null,
                    order_type: null,
                    request_notes: null,
                },
                lists: {
                    employers: [],
                    campaigns: [],
                    jobs: [],
                },
                current_fulfillment_requests: {
                    employer_name: null,
                    campaign_name: null,
                    list: [],
                }
            }
        },
        watch: {
        },
        computed: {
        },
        methods: {
            refresh(budger_order_id) {
                this.loading = true;

                return axios.get(url(`de/fulfillment/new?budger_order_id=${budger_order_id}`))
                    .then((response) => {
                        this.form_data = response.data.form_data;
                        this.lists.employers = response.data.lists.employers;
                        this.lists.campaigns = response.data.lists.campaigns;
                        this.lists.periods = response.data.lists.periods;
                        this.lists.jobs = response.data.lists.jobs;

                        this.loading = false;

                        this.refreshCurrentFulfillmentRequests();
                    })
                
            },
            clearCampaigns() {
                this.lists.campaigns = [];
                this.form_data.campaign_id = null;

                this.clearPeriods();
                this.clearJobs();
            },
            refreshCampaigns() {
                this.clearCampaigns();

                if(! this.form_data.employer_id) {
                    return;
                }

                return axios.get(url(`de/fulfillment/employers/${this.form_data.employer_id}/campaigns`))
                    .then((response) => {
                        this.lists.campaigns = response.data.campaigns;
                    })
            },
            clearPeriods() {
                this.lists.periods = [];
                this.form_data.request_for_periods = [];
            },
            refreshPeriods() {
                this.clearPeriods();

                if(! this.form_data.campaign_id) {
                    return;
                }

                return axios.get(url(`de/fulfillment/campaigns/${this.form_data.campaign_id}/periods`))
                    .then((response) => {
                        this.lists.periods = response.data.periods;
                        this.form_data.request_for_periods = [];
                    })
            },
            clearJobs() {
                this.lists.jobs = [];

                this.form_data.job_id = null;
                this.form_data.job_pay = null;
                this.form_data.job_hometime = null;
                this.form_data.job_equipment = null;
            },
            refreshJobs() {
                this.clearJobs();

                if(! this.form_data.campaign_id) {
                    return;
                }

                return axios.get(url(`de/fulfillment/campaigns/${this.form_data.campaign_id}/jobs`))
                    .then((response) => {

                        this.lists.jobs = response.data.jobs;
                    })
            },
            refreshJobInfo() {
                if(! this.form_data.job_id) {
                    return;
                }

                return axios.get(url(`de/fulfillment/jobs/${this.form_data.job_id}`))
                    .then((response) => {
                        this.form_data.job_pay = response.data.job_pay;
                        this.form_data.job_hometime = response.data.job_hometime;
                        this.form_data.job_equipment = response.data.job_equipment;
                    })
            },
            clearCurrentFulfillmentRequests() {
                this.current_fulfillment_requests = {
                    employer_name: null,
                    campaign_name: null,
                    list: [],
                };
            },
            refreshCurrentFulfillmentRequests() {
                this.clearCurrentFulfillmentRequests();

                if(! this.form_data.employer_id) {
                    return;
                }
                
                let campaignId = null;
                if(this.form_data.campaign_id) {
                    campaignId = this.form_data.campaign_id;
                }

                return axios.get(url(`de/fulfillment/employer/${this.form_data.employer_id}/fulfillment-requests?campaign_id=${campaignId}`))
                    .then((response) => {
                        this.current_fulfillment_requests = response.data;
                    })
            },
            save() {
                return axios.post(url(`de/fulfillment/create`), {
                    'data': this.form_data
                }).then((response) => {
                    this.$router.push({ path: `/admin/driver-engage/fulfillment`});
                });
            },
        },
        mounted() {
        },
        created() {
            let budger_order_id = this.$route.query.budger_order_id;
            this.refresh(budger_order_id);
        },
    }
</script>

<style scoped>
    div.field {
        clear: both;
        margin-bottom: 25px;
    }
    .fa-stack {
        font-size: 0.5em;
    }
    i {
        vertical-align: middle;
    } 
</style>